module.exports = __webpack_public_path__ + "static/media/EastHampton_15.ac67f28b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/EastHampton_15.JPG
// module id = 234
// module chunks = 0